import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-90px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
  <Reveal y={20}>
    <div className="flex items-center gap-4" data-testid={`chapter-${index}`}>
      <span
        className={`font-display text-xs font-medium tracking-[0.35em] ${
          dark ? "text-diem-sky" : "text-diem-blue"
        }`}
      >
        {index}
      </span>
      <span className={`h-px w-10 ${dark ? "bg-white/20" : "bg-diem-line"}`} />
      <span
        className={`text-xs font-semibold uppercase tracking-[0.25em] ${
          dark ? "text-white/50" : "text-diem-muted"
        }`}
      >
        {label}
      </span>
    </div>
  </Reveal>
);

export const SectionHeading = ({ children, dark = false, className = "" }) => (
  <h2
    className={`font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] ${
      dark ? "text-white" : "text-diem-ink"
    } ${className}`}
  >
    {children}
  </h2>
);
